import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { UserService } from '@core/services/user.service';
import { OutlineStarIconComponent } from '@shared/icons/outline-star-icon.component';
import { SolidStarIconComponent } from '@shared/icons/solid-star-icon.component';
import { PerformanceItemRankingData } from '@features/models/fans/performance-item-rankings/performance-item-ranking-data';
import { PerformanceItemRatingData } from '@features/models/fans/performance-item-ratings/performance-item-rating-data';
import { ProgrammeLocationPerformanceDetails } from '@features/models/events/programme-location-performances/programme-location-performance-details';
import { PerformanceRankingPuck } from './models/performance-ranking-puck';
import { PerformanceItem } from './models/performance-item';
import { PerformanceRankingSlot } from './models/performance-ranking-slot';
import { PerformanceRatingsEnum } from '@features/enums/performance-ratings-enum';
import { RateWithTrimComponent } from '@shared/components/fans/rate-with-trim/rate-with-trim.component';
import { RatingWithTrim } from '@shared/models/fans/rating-with-trim';

@Component({
  selector: 'app-programme-performance-ranking',
  imports: [CommonModule, OutlineStarIconComponent, SolidStarIconComponent, DragDropModule, RateWithTrimComponent],
  templateUrl: './programme-performance-ranking.component.html'
})
export class ProgrammePerformanceRankingComponent implements OnChanges {

  @Input() programmePerformanceList?: ProgrammeLocationPerformanceDetails[] = [];
  @Input() performanceItemRankingList?: PerformanceItemRankingData[] = [];
  @Input() performanceItemRatingList?: PerformanceItemRatingData[] = [];
  @Output() performanceItemRankedList = new EventEmitter<PerformanceItemRankingData[]>();
  @Output() performanceItemRated = new EventEmitter<PerformanceItemRatingData>();

  protected readonly PerformanceRatingsEnum = PerformanceRatingsEnum;

  public _userService = inject(UserService);

  public showRatingModal = false;
  public performanceRankingSlotList?: PerformanceRankingSlot[];
  private draggedPerformanceSlot?: PerformanceRankingSlot;
  public dragReady: boolean = false;
  public openPerformanceRanking?: PerformanceRankingPuck;
  public currentPerformanceRating?: RatingWithTrim;

  ngOnChanges(changes: SimpleChanges): void {
      if (
        changes['programmePerformanceList'] ||
        changes['performanceItemRankingList']
      ) {
          this.buildPerformanceItemRankList();
      }
  }

  private buildPerformanceItemRankList() {

    if (this.programmePerformanceList !== undefined) {
      
      const performanceList: PerformanceItem[] = this.programmePerformanceList!
        .flatMap(programmePerformance =>
            programmePerformance.performance?.performanceItemList?.map(
                performanceItem =>
                    new PerformanceItem(
                        programmePerformance.sequenceNo ?? 0,
                        performanceItem.sequenceNo ?? 0,
                        performanceItem.id,
                        performanceItem.name,
                        programmePerformance.performance?.id,
                        programmePerformance.performance?.name ?? '',
                        performanceItem.performerList?.map(
                            performer => performer.performer?.name ?? ''
                        ) ?? []
                    )
            ) ?? []
        )
        .sort((a, b) =>
            a.programmeSequenceNo - b.programmeSequenceNo ||
            a.performanceSequenceNo - b.performanceSequenceNo ||
            a.performanceItemName.localeCompare(
                b.performanceItemName
            )
        );

      const performanceCount = performanceList.length;

      const performanceRankingBuildList =
        Array.from(
          { length: performanceCount },
          (_, index) =>
            ({
              sequenceNo: index,
              performanceRanking: undefined as (PerformanceRankingPuck | undefined)
            })
        );

      if (this.performanceItemRankingList) {
        this.performanceItemRankingList.forEach(ranking => {

          const index = performanceList.findIndex(
              performance => performance.performanceItemId === ranking.performanceItemId
          );

          let performance: PerformanceItem | undefined;

          if (index !== -1) {
              performance = performanceList.splice(index, 1)[0];
          }

          if (performance) {
            performanceRankingBuildList[ranking.ranking].performanceRanking = new PerformanceRankingPuck(
              ranking.ranking,
              performance.performanceItemId,
              performance.performanceItemName,
              performance.performanceName,
              performance.performerNameList,
              ranking.id,
              true,
              ranking.locked            
            );
          }
        });
      }

      var sequenceNo = 0;
      var performanceIndex = 0;

      while (performanceIndex <= performanceList.length - 1) {
      
        if (performanceRankingBuildList[sequenceNo].performanceRanking === undefined) {
          var performance = performanceList[performanceIndex];

          performanceRankingBuildList[sequenceNo].performanceRanking = new PerformanceRankingPuck(
            sequenceNo,
            performance.performanceItemId,
            performance.performanceItemName,
            performance.performanceName,
            performance.performerNameList
          );

          performanceIndex++;
        }

        sequenceNo++;
      }

      if (this.performanceItemRatingList) {

        this.performanceItemRatingList.forEach(rating => {
          var performanceRankingPuck = performanceRankingBuildList.find(performanceRanking => performanceRanking.performanceRanking?.performanceItemId === rating.performanceItemId);

          if (performanceRankingPuck?.performanceRanking) {
            performanceRankingPuck.performanceRanking.performanceItemRatingid = rating.performanceItemId;
            performanceRankingPuck.performanceRanking!.rating = {
              rating: rating.rating,
              trim: rating.trim,
              comment: rating.comment
            }
          }
        });

      }

      /*performanceList.forEach(performance => {

        if (performanceRankingBuildList[sequenceNo].performanceRanking === undefined) {
          performanceRankingBuildList[sequenceNo].performanceRanking = new PerformanceRankingPuck(
            sequenceNo,
            performance.performanceItemId,
            performance.performanceItemName,
            performance.performanceName,
            performance.performerNameList
          );
        }

        sequenceNo++;
      });*/

      this.performanceRankingSlotList = performanceRankingBuildList.filter(
            (slot) => slot.performanceRanking !== undefined
          )
        .map(slot => new PerformanceRankingSlot(
            slot.sequenceNo,
            slot.performanceRanking!
          ));

      console.log("Performance List");
      console.log(this.performanceRankingSlotList);
    }

  }

  /*public getPerformanceRating(performanceId?: string): PerformanceRatingData | undefined {
    return this.performanceRatingList?.find(performanceRating => performanceRating.performanceId == performanceId);
  }

  public ratePerformance(performanceId: string | undefined, rating: string) {
    console.log(performanceId, rating);
    if (this.performanceRatingList && performanceId) {
      var performanceRating = this.getPerformanceRating(performanceId);
      if (performanceRating?.rating !== rating) {

        const changedPerformanceRating: PerformanceRatingData = {
          id: performanceRating?.id,
          performanceId: performanceId,
          rating: rating
        };

        if (performanceRating !== undefined) {
          performanceRating.rating = rating;
        }
        else {
          this.performanceRatingList.push(changedPerformanceRating);
        }

        this.productionDetailsService.setRating(changedPerformanceRating);
      }
    }
  }*/

  public onDrag(index: number) {
    if (!this.performanceRankingSlotList) return;
    this.dragReady = true;
    this.draggedPerformanceSlot = this.performanceRankingSlotList[index];
  }

  public onDragStop() {
    this.dragReady = false;
  }

  public onDrop(event: CdkDragDrop<PerformanceRankingSlot[]>) {
    if (!this.performanceRankingSlotList || !this.draggedPerformanceSlot) return;

    var performanceRankingChangeList = new Array<PerformanceRankingSlot>();
    const vacatedIndex = event.previousIndex;
    const toOccupyIndex = event.currentIndex;
    
    performanceRankingChangeList.push(...this.MovePerformanceRankingSlot(vacatedIndex, toOccupyIndex));

    this.draggedPerformanceSlot.sequenceNo = toOccupyIndex;
    this.draggedPerformanceSlot.performanceRanking.ranked = true;
    this.performanceRankingSlotList[toOccupyIndex] = this.draggedPerformanceSlot;
    performanceRankingChangeList.push(this.draggedPerformanceSlot);
    this.draggedPerformanceSlot = undefined;

    if (performanceRankingChangeList.length > 0) {
      this.performanceItemRankedList.emit(performanceRankingChangeList.map(change => ({
        performanceItemId: change.performanceRanking.performanceItemId,
        ranking: change.sequenceNo,
        locked: false
      })));
/*

*/
      /*const gameRankingChange: GameRankingChangeData = {
        gameRankingList: this.GameRankingPuckListToGameRankingData(changedGameRankingPuckList)
      }
      this.UpdateGameRatings(gameRankingChange);*/
    }
  }

  private MovePerformanceRankingSlot(vacatedIndex: number, toOccupyIndex: number): PerformanceRankingSlot[] {
    if (!this.performanceRankingSlotList) return[];

    var performanceRankingChangeList = new Array<PerformanceRankingSlot>();

    if (vacatedIndex < toOccupyIndex) {
      for (let index = vacatedIndex; index < toOccupyIndex; index++) {
        this.performanceRankingSlotList[index] = this.performanceRankingSlotList[index + 1];
        this.performanceRankingSlotList[index]!.sequenceNo = index;

        if (this.performanceRankingSlotList[index].performanceRanking.ranked) {
          performanceRankingChangeList.push(this.performanceRankingSlotList[index]!);
        }
      }
    }
    else {
      for (let index = vacatedIndex; index > toOccupyIndex; index--) {
        this.performanceRankingSlotList[index] = this.performanceRankingSlotList[index - 1];
        this.performanceRankingSlotList[index]!.sequenceNo = index;

        if (this.performanceRankingSlotList[index].performanceRanking.ranked) {  
          performanceRankingChangeList.push(this.performanceRankingSlotList[index]!);
        }
      }
    }

    return performanceRankingChangeList;
  }

  openRatingModal(performanceRanking: PerformanceRankingPuck): void {
    this.openPerformanceRanking = performanceRanking;

    this.currentPerformanceRating = performanceRanking.rating
      ? { ...performanceRanking.rating }
      : undefined;
  }

  closeRatingModal(): void {
    this.openPerformanceRanking = undefined;
    this.currentPerformanceRating = undefined;
  }

  saveRatingValue(): void {
    if (this.currentPerformanceRating && this.openPerformanceRanking) {
      this.openPerformanceRanking.rating = this.currentPerformanceRating;

      this.performanceItemRated.emit({
        performanceItemId: this.openPerformanceRanking.performanceItemId,
        rating: this.currentPerformanceRating.rating,
        trim: this.currentPerformanceRating.trim,
        comment: this.currentPerformanceRating.comment
      });
    }
    this.closeRatingModal();
  }

}
